import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ProgressState } from '../model/progress-state';

@Injectable()
export class ProgressBarService {
  constructor() {
    this.stateChange = this._stateChange.asObservable();
  }

  private _state: ProgressState;
  private _stateChange: Subject<ProgressState> = new Subject();
  get currentState(): ProgressState {
    return this._state;
  }
  readonly stateChange: Observable<ProgressState>;

  start(): void {
    this._state = ProgressState.Active;
    this._stateChange.next(this._state);
  }

  stop(): void {
    this._state = ProgressState.Inactive;
    this._stateChange.next(this._state);
  }
}
